import {
  Button,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { fetchResources, setlistsize, fail } from "../../actions"
import { Link } from "react-router-dom"
import { ErrorDialog, PageContainer, TranslatedTable } from "../../components"
import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

const RESELLER_INVITE_URL =
  "https://admin.microsoft.com/Adminportal/Home?invType=ResellerRelationship&partnerId=c3f11859-6935-429b-bc3e-114aff4e9174&msppId=0#/partners/invitation"

class Customers extends React.Component {
  state = {
    search: "",
    updatingCustomerList: false,
    error: null,
    addModalOpen: false,
    copied: false,
  }

  copyInviteLink = async () => {
    try {
      await navigator.clipboard.writeText(RESELLER_INVITE_URL)
      this.setState({ copied: true })
    } catch (err) {
      // fallback for browsers without clipboard API permission
      const input = document.getElementById("resellerInviteUrl")
      if (input) {
        input.select()
        document.execCommand("copy")
        this.setState({ copied: true })
      }
    }
  }

  componentDidMount = () => this.props.fetchResources({ resource: "customers" })

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  updateCustomerList = () => {
    this.setState({ updatingCustomerList: true })
    axios
      .post("/customers/update")
      .then(() =>
        this.props.fetchResources({ resource: "customers", force: true })
      )
      .catch((error) => {
        this.props.fail(null, error)
        this.setState({ error })
      })
      .finally(() => this.setState({ updatingCustomerList: false }))
  }

  render = () => {
    const customers = this.props.customers.customers.filter((c) =>
      c.companyName.toLowerCase().includes(this.state.search.toLowerCase())
    )

    const { t } = this.props
    const columns = [
      {
        Header: t("_name"),
        accessor: "companyName",
        Cell: (props) => (
          <Link to={`/customers/${props.original.id}`}>{props.value}</Link>
        ),
      },
      {
        Header: t("_customerID"),
        accessor: "id",
      },
    ]

    return (
      <PageContainer title={t("_customers")}>
        <ErrorDialog
          open={this.state.error ? true : false}
          title={t("_failedToUpdateCustomers")}
          toggle={() =>
            this.setState({
              error: null,
            })
          }
        />
        <Row>
          <Col sm="6">
            <Input
              type="text"
              name="search"
              id="search"
              placeholder={t("_search")}
              value={this.state.search}
              onChange={this.handleChange}
            />
          </Col>

          <Col sm="6">
            <Button
              className="float-right"
              color="primary"
              onClick={this.updateCustomerList}
              disabled={this.state.updatingCustomerList}
            >
              {t("_updateCustomerList")}
            </Button>
            <Button
              className="float-right mr-2"
              color="success"
              onClick={() =>
                this.setState({ addModalOpen: true, copied: false })
              }
            >
              {`+ ${t("_addCustomer")}`}
            </Button>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.addModalOpen}
          toggle={() => this.setState({ addModalOpen: false })}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({ addModalOpen: false })}>
            {t("_addCustomer")}
          </ModalHeader>
          <ModalBody>
            <p>{t("_addCustomerInstructions")}</p>
            <InputGroup>
              <Input
                id="resellerInviteUrl"
                readOnly
                value={RESELLER_INVITE_URL}
                onFocus={(e) => e.target.select()}
              />
              <InputGroupAddon addonType="append">
                <Button
                  color={this.state.copied ? "success" : "primary"}
                  onClick={this.copyInviteLink}
                >
                  {this.state.copied ? t("_copied") : t("_copyLink")}
                </Button>
              </InputGroupAddon>
            </InputGroup>
            <p className="mt-3 mb-0">
              <small>{t("_addCustomerAfterAccept")}</small>
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => this.setState({ addModalOpen: false })}
            >
              {t("_cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        <hr />

        <TranslatedTable
          columns={columns}
          data={customers}
          fetching={
            this.props.customers.fetching || this.state.updatingCustomerList
          }
          handleresize={this.props.setlistsize}
          listSize={this.props.list.listSetting}
        />
        <hr />
      </PageContainer>
    )
  }
}

export default connect((s) => s, { fetchResources, setlistsize, fail })(
  withTranslation()(Customers)
)
